import { useState } from 'react';
import '../HomePage/Quotes.css';
import "../HomePage/HomeInsurance.css"


const AddonsPOP = ({ Addons, onAddonsSubmit }) => {
    const [selectedAddons, setSelectedAddons] = useState([]);
    const addAddons = (Key, Value, addonsID) => {
        const IsAvailable = selectedAddons(r => r.AddonsID === addonsID).length > 0;
        if (IsAvailable) {

        } else {

        }
    }
    console.log(Addons);
    return (
        <>
            <div>
                <div className="addons_Add">
                    <div className="compae1 pt-2">
                        <h5>Select Addons</h5>
                    </div>
                    {Array.isArray(Addons) && Addons.map(r => <div className="compae1">
                        <input type="checkbox" value={r.addonsID} className="compareChecked" onChange={(e) => addAddons(e.target.name, e.target.value, r.addonsID)} />
                        <label htmlFor="" className="mx-2">{r.label}</label>
                        
                    </div>)}
                    
                    <div className="view_quotes text-center">
                        <button type="submit" onClick={() => onAddonsSubmit(selectedAddons)} className="SMCLarg1 my-3">Update</button>
                    </div>
                </div>
            </div>
        </>
    );

}
export default AddonsPOP;